import React from 'react'
import ReactCrop, { makeAspectCrop } from 'react-image-crop'

import {
  NumericStepper as Stepper,
  Step,
  StepButton
} from '../../../components/NumericStepper'

class ProfileSetupWizard extends React.Component {
  constructor(props) {
    super(props)

    this.logoCropDefaults = {
      x: 0,
      y: 0,
      width: 100,
      aspect: 1
    }

    this.mastheadCropDefaults = {
      x: 0,
      y: 0,
      width: 100,
      aspect: 16 / 4
    }

    this.state = {
      toSubmit: {
        title: props.profile.title,
        about: null,
        logoBlob: null,
        mastheadBlob: null
      },
      submitInProgress: false,
      f1: '',
      f2: '',
      activeStep: 0,
      uncroppedLogo: '',
      uncroppedMasthead: '',
      logoPixelCrop: {},
      logoCrop: makeAspectCrop(this.logoCropDefaults),
      mastheadPixelCrop: {},
      mastheadCrop: makeAspectCrop(this.mastheadCropDefaults)
    }
  }

  requiredSteps = {
    0: true,
    4: true
  }

  renderMCE = keyInStore => {
    return (
      <textarea
        className="text-input full"
        style={{ width: '100%' }}
        onChange={t => {
          this.setState({
            ...this.state,
            toSubmit: {
              ...this.state.toSubmit,
              [keyInStore]: t.target.value
            }
          })
        }}
        value={this.state.toSubmit[keyInStore] || ''}>
      </textarea>
    )

    /*
     *return (<TinyMCE
     *      content={this.state.toSubmit[keyInStore] || ''}
     *      config={h2.getOptionsTinyMCE()}
     *      className="text-input"
     *      onBlur={(t) => {
     *          this.setState({
     *              ...this.state,
     *              toSubmit: {
     *                  ...this.state.toSubmit,
     *                  [keyInStore]: t.target.getContent()
     *              }
     *          })
     *      }}
     *  /> )
     */
  }

  renderConfirm = () => {
    return (
      <div>
        <p>Please confirm your choices:</p>
        <div className="row" style={{ fontSize: '1.2rem' }}>
          <div className="col-xs-3 bold">Title:</div>
          <div className="col-xs-9">{this.state.toSubmit.title}</div>
        </div>
        <div className="row" style={{ fontSize: '1.2rem' }}>
          <div className="col-xs-3 bold">About:</div>
          <div className="col-xs-9">{this.state.toSubmit.about}</div>
        </div>
        <div className="row" style={{ fontSize: '1.2rem' }}>
          <div className="col-xs-3 bold">Logo Set:</div>
          <div className="col-xs-9">
            {this.state.toSubmit.logoBlob ? (
              <span className="checked"></span>
            ) : (
              <span></span>
            )}
          </div>
        </div>
        <div className="row" style={{ fontSize: '1.2rem' }}>
          <div className="col-xs-3 bold">Masthead Set:</div>
          <div className="col-xs-9">
            {this.state.toSubmit.mastheadBlob ? (
              <span className="checked"></span>
            ) : (
              <span></span>
            )}
          </div>
        </div>

        <p className="row" style={{ marginTop: '20px' }}>
          <div className="col-xs-12">
            If they all look good, click the finish button below
          </div>
        </p>
      </div>
    )
  }

  onFileChange = eventName => e => {
    e.preventDefault()
    let files

    if (e.dataTransfer) {
      files = e.dataTransfer.files
    } else if (e.target) {
      files = e.target.files
    }

    const reader = new FileReader()

    reader.onload = () => {
      const data = {}

      data[eventName] = reader.result
      this.setState({
        ...this.state,
        ...data
      })
    }
    reader.readAsDataURL(files[0])
  }

  profileTitle = () => {
    return (
      <div>
        <label htmlFor="profileTitleInput">
          <p>First, what should this be called?</p>
        </label>
        <input
          type="text"
          id="profileTitleInput"
          className="form-control input-lg"
          value={this.state.toSubmit.title}
          onChange={t =>
            this.setState({
              ...this.state,
              toSubmit: {
                ...this.state.toSubmit,
                title: t.target.value
              }
            })}
        />
      </div>
    )
  }

  profileAbout = () => {
    return (
      <div>
        <p>Next, describe what this entity does. </p>
        {this.renderMCE('about')}
      </div>
    )
  }

  dataURItoBlob = dataURI => {
    // convert base64/URLEncoded data component to raw binary data held in a string
    let byteString

    if (dataURI.split(',')[0].indexOf('base64') >= 0) {
      byteString = atob(dataURI.split(',')[1])
    } else {
      byteString = unescape(dataURI.split(',')[1])
    }

    // separate out the mime component
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
    // write the bytes of the string to a typed array
    const ia = new Uint8Array(byteString.length)

    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i)
    }

    return new Blob([ia], { type: mimeString })
  }

  extractCroppedImg = (image, pixelCrop, key) => {
    const img = new Image()

    img.src = image
    const canvas = document.createElement('canvas')

    canvas.width = pixelCrop.width
    canvas.height = pixelCrop.height
    const ctx = canvas.getContext('2d')
    const baseThis = this

    img.onload = function () {
      ctx.drawImage(
        img,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        pixelCrop.width,
        pixelCrop.height
      )
      baseThis.setState({
        ...baseThis.state,
        toSubmit: {
          ...baseThis.state.toSubmit,
          [key]: baseThis.dataURItoBlob(canvas.toDataURL('image/jpeg'))
        }
      })
    }

    //console.log("d", this.dataURItoBlob(canvas.toDataURL('image/jpeg')))
  }

  isThumbCropAdvanceable = () => {
    const isCropSelected = this.state.logoPixelCrop.hasOwnProperty('x')
    const isImageUploaded = this.state.uncroppedLogo !== ''

    return !isImageUploaded || (isImageUploaded && isCropSelected)
  }

  cropThumbnail = () => {
    const key = 'uncroppedLogo'

    return (
      <div>
        <p>Now, upload an image you wish to use for the logo.</p>
        <input
          type="file"
          value={this.state.f1}
          id="f1"
          onChange={this.onFileChange(key)}
          style={{ fontSize: '1rem', marginBottom: '15px' }}
        />
        <div className="row">
          <div className="col-xs-12">
            <ReactCrop
              src={this.state[key]}
              crop={this.state.logoCrop}
              style={{ flex: 1 }}
              keepSelection={true}
              onImageLoaded={image => {
                //console.log("fff", image.width,  image.height)
                this.setState({
                  ...this.state,
                  logoCrop: makeAspectCrop(
                    {
                      ...this.logoCropDefaults,
                      width: Math.min(
                        this.logoCropDefaults.width,
                        image.width,
                        image.height
                      )
                    },
                    image.width / image.height
                  )
                })
              }}
              onChange={(crop, pixelCrop) => {
                this.setState({
                  ...this.state,
                  logoPixelCrop: pixelCrop,
                  logoCrop: crop
                })
              }}
            />
            <div
              style={{
                fontSize: '1.1rem',
                marginTop: '15px',
                fontWeight: 'bold',
                display: this.state.uncroppedLogo !== '' ? 'block' : 'none'
              }}>
              Use your mouse to click and drag on the above image to select the part you
              wish to use for the logo.
              <i
                className="fal fa-check"
                style={{
                  color: 'green',
                  display: this.isThumbCropAdvanceable() ? 'inline-block' : 'none'
                }}>
              </i>
            </div>
          </div>
        </div>
      </div>
    )
  }

  isThumbMastheadAdvanceable = () => {
    const isCropSelected = this.state.mastheadPixelCrop.hasOwnProperty('x')
    const isImageUploaded = this.state.uncroppedMasthead !== ''

    return !isImageUploaded || (isImageUploaded && isCropSelected)
  }

  cropMasthead = () => {
    const key = 'uncroppedMasthead'

    return (
      <div>
        <p>Now, upload an image you wish to use for the background of the header.</p>
        <input
          type="file"
          value={this.state.f2}
          id="f2"
          onChange={this.onFileChange(key)}
          style={{ fontSize: '1rem', marginBottom: '15px' }}
        />
        <div className="row">
          <div className="col-xs-12">
            <ReactCrop
              src={this.state[key]}
              crop={this.state.mastheadCrop}
              keepSelection={true}
              style={{ width: '100%' }}
              onImageLoaded={image => {
                //console.log(image.width / image.height)
                this.setState({
                  ...this.state,
                  mastheadCrop: makeAspectCrop(
                    {
                      ...this.mastheadCropDefaults,
                      width: Math.min(this.mastheadCropDefaults.width, image.width)
                    },
                    image.width / image.height
                  )
                })
              }}
              onChange={(crop, pixelCrop) => {
                this.setState({
                  ...this.state,
                  mastheadPixelCrop: pixelCrop,
                  mastheadCrop: crop
                })
              }}
            />
            <div
              style={{
                fontSize: '1.1rem',
                marginTop: '15px',
                width: '100%',
                fontWeight: 'bold',
                display: this.state.uncroppedMasthead !== '' ? 'block' : 'none'
              }}>
              Use your mouse to click and drag on the above image to select the part you
              wish to use for the logo.
              <i
                className="fal fa-check"
                style={{
                  color: 'green',
                  display: this.isThumbMastheadAdvanceable() ? 'inline-block' : 'none'
                }}>
              </i>
            </div>
          </div>
        </div>
      </div>
    )
  }

  generateContent = () => {
    switch (this.state.activeStep) {
      case 0:
        return this.profileTitle()
      case 1:
        return this.profileAbout()
      case 2:
        return this.cropThumbnail()
      case 3:
        return this.cropMasthead()
      case 4:
        return this.renderConfirm()
      default:
        return <h1>Here</h1>
    }
  }

  formAdvance = baseThis => e => {
    e.preventDefault()
    //Capture crop
    let advanceOnComplete = true

    switch (baseThis.state.activeStep) {
      case 2:
        baseThis.extractCroppedImg(
          baseThis.state.uncroppedLogo,
          baseThis.state.logoPixelCrop,
          'logoBlob'
        )
        break
      case 3:
        baseThis.extractCroppedImg(
          baseThis.state.uncroppedMasthead,
          baseThis.state.mastheadPixelCrop,
          'mastheadBlob'
        )
        break
      case 4:
        this.setState({
          ...this.state,
          submitInProgress: true
        })
        baseThis.props
          .profileUpdateAction(
            baseThis.props.profile.type,
            baseThis.props.profile.id,
            baseThis.state.toSubmit
          )
          .then(() => {
            document.getElementById('pagetitle').innerHTML = baseThis.state.toSubmit.title
            document.title = baseThis.state.toSubmit.title
            baseThis.props.modalCloseAction() //should be tutorial
          })
          .catch(() =>
            this.setState({
              ...this.state,
              submitInProgress: false
            })
          )
        advanceOnComplete = false
        break
    }

    if (advanceOnComplete) {
      baseThis.setState({
        ...baseThis.state,
        activeStep: baseThis.state.activeStep + 1
      })
    }
  }

  renderSkip = () => {
    if (this.requiredSteps[this.state.activeStep]) {
      return null
    }

    return (
      <button
        type="submit"
        className="btn btn-primary pull-right"
        style={{ marginRight: '10px' }}>
        Skip
      </button>
    )
  }

  isNextDisabled = () => {
    let disabled = false

    switch (this.state.activeStep) {
      case 2:
        disabled = !this.isThumbCropAdvanceable()
      case 3:
        disabled = !this.isThumbMastheadAdvanceable()
    }

    return disabled
  }
  renderNext = () => {
    if (this.state.activeStep === 4) {
      return (
        <button
          type="submit"
          className="btn btn-success pull-right"
          disabled={this.state.submitInProgress}>
          Finish{' '}
          <i
            className="fal fa-spin fa-spinner"
            style={{ display: this.state.submitInProgress ? 'initial' : 'none' }}>
          </i>
        </button>
      )
    }

    return (
      <button type="submit" className="btn btn-success pull-right">
        Next
      </button>
    )
  }

  render = () => (
    <form onSubmit={this.formAdvance(this)} className="">
      <Stepper activeStep={this.state.activeStep}>
        <Step onClick={() => this.setState({ ...this.state, activeStep: 0 })}>
          <StepButton>Name</StepButton>
        </Step>
        <Step onClick={() => this.setState({ ...this.state, activeStep: 1 })}>
          <StepButton>About</StepButton>
        </Step>
        <Step onClick={() => this.setState({ ...this.state, activeStep: 2 })}>
          <StepButton>Logo</StepButton>
        </Step>
        <Step onClick={() => this.setState({ ...this.state, activeStep: 3 })}>
          <StepButton>Masthead</StepButton>
        </Step>
        <Step onClick={() => this.setState({ ...this.state, activeStep: 4 })}>
          <StepButton>Confirmation</StepButton>
        </Step>
      </Stepper>
      <div style={{ minHeight: '250px' }}>{this.generateContent()}</div>

      <div className="actions row" style={{ marginTop: '25px' }}>
        <div className="col-xs-12">
          {this.renderNext()}
          {this.renderSkip()}
        </div>
      </div>
    </form>
  )
}

export default ProfileSetupWizard
